import { useFormikContext } from "formik";
import React, { FunctionComponent } from "react";
import { HelpForm } from "./HelpForm";
import { TaxCodeHelpDialog } from "./TaxCodeHelpDialog";

export interface Props {
  code: string;
  clearCode: () => void;
}

export const codesForSchuldSaldoVerzekeringBouwsparenBefore89 = ["3352", "4352"];

export const HelpSchuldSaldoVerzekeringBouwsparenBefore89: FunctionComponent<Props> = ({ code, clearCode }) => {
  const { setFieldValue } = useFormikContext<any>();

  const handleSubmit = React.useCallback(
    (values) => {
      const { premie, verzekerdBedrag, bedragLening } = values;
      const limitBouwsparen = 49578.7;
      const bouwSparen = (premie * Math.min(limitBouwsparen, verzekerdBedrag, bedragLening)) / verzekerdBedrag || 0;
      const langetermijnsparen = premie - bouwSparen;

      setFieldValue(`c${code}`, bouwSparen);
      setFieldValue(`c${parseInt(code as string, 10) + 2}`, langetermijnsparen);
      clearCode();
    },
    [clearCode, code, setFieldValue]
  );

  return (
    <TaxCodeHelpDialog
      code={code}
      onClose={clearCode}
      dialogForCodes={codesForSchuldSaldoVerzekeringBouwsparenBefore89}
    >
      <HelpForm fields={["premie", "verzekerdBedrag", "bedragLening"]} onSubmit={handleSubmit} code={code} />
    </TaxCodeHelpDialog>
  );
};

HelpSchuldSaldoVerzekeringBouwsparenBefore89.displayName = "HelpSchuldSaldoVerzekeringBouwsparenBefore89";
